import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonComponent, ButtonType } from '@app/components/button';
import { CardComponent } from '@app/components/card';
import { TitleComponent } from '@app/components/title-section';
import { ViewComponent, ViewDirection } from '@app/components/view';
import { AdminTenantService } from '@app/services/admin-tenant/admin-tenant.service';
import { Spacing } from '@app/shared/types';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { EnterpriseTenant } from '@skyfit/core-data-library';
import { TechnicalSupportManager } from '@skyfit/core-data-library/models/advanced-support/advancedSupport';
import { ClientSuccessManager } from '@skyfit/core-data-library/models/client-success/clientSuccess';
import { Observable } from 'rxjs/dist/types';

@Component({
  selector: 'app-support',
  standalone: true,
  imports: [
    CardComponent,
    ButtonComponent,
    ViewComponent,
    TitleComponent,
    CommonModule,
    TranslateDirective,
    TranslatePipe,
  ],
  templateUrl: './support.component.html',
})
export class SupportComponent implements OnInit {
  private readonly adminTenantService = inject(AdminTenantService);
  readonly destroyRef = inject(DestroyRef);
  tenant$: Observable<any>;
  tenant?: EnterpriseTenant;
  technicalManager?: TechnicalSupportManager;
  customerManager?: ClientSuccessManager;
  ViewDirection = ViewDirection;
  ButtonType = ButtonType;
  Spacing = Spacing;

  ngOnInit() {
    this.tenant$ = this.adminTenantService.tenant$;
    this.tenant$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((tenant) => {
        if (tenant) {
          this.tenant = tenant;
          this.technicalManager =
            this.tenant?.features?.advancedSupport?.config?.technicalSupportManager;

          this.customerManager =
            this.tenant?.features?.clientSuccess?.config?.clientSuccessManager;
        }
      });
  }

  openContactList() {
    window.open('https://aaptiv.com/enterprise-support/contact/', '_blank');
  }

  submitSupportRequest() {
    window.open('https://aaptiv.com/enterprise-support/', '_blank');
  }
}
